import { defineStore } from '/src/core/store';

export const useGeolocationStore = defineStore('location', {
	state: () => ({
		position: {},
	}),
	persist: {
		storage: 'local',
		pick: ['position'],
	},
	getters: {
		coordinates () {
			return this.position?.coords;
		},
	},
	actions: {
		setPosition (position) {
			if (!position) {
				return;
			}

			const { timestamp, coords } = position;
			const { latitude, longitude, accuracy } = coords;

			this.position = {
				timestamp,
				coords: {
					latitude,
					longitude,
					accuracy,
				},
			};
		},
	},
});
